var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftcards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.198,
    height: 34.485,
    viewBox: "0 0 36.198 34.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Cadeaukaarten",
    d: "M35.128,10.14H31.237a5.342,5.342,0,0,0-9.5-4.73l-.892,1.2-.892-1.214a5.344,5.344,0,0,0-9.5,4.748H6.57a3.542,3.542,0,0,0-3.552,3.57L3,33.344a3.557,3.557,0,0,0,3.57,3.57H35.128a3.557,3.557,0,0,0,3.57-3.57V13.71A3.557,3.557,0,0,0,35.128,10.14ZM26.2,6.57a1.785,1.785,0,1,1-1.785,1.785A1.79,1.79,0,0,1,26.2,6.57Zm-10.709,0a1.785,1.785,0,1,1-1.785,1.785A1.79,1.79,0,0,1,15.494,6.57ZM35.128,33.344H6.57v-3.57H35.128Zm0-8.924H6.57V13.71h9.067l-3.713,5.051,2.892,2.088,6.033-8.211,6.033,8.211,2.892-2.088L26.061,13.71h9.067Z",
    transform: "translate(-2.75 -2.678)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftcards);
export default __webpack_public_path__ + "static/media/Giftcards.786ac2317e8c2fbbd328760d9f3cff47.svg";
export { ForwardRef as ReactComponent };